import { defineMessages } from 'react-intl';

export const commentsMessageDefinitions = defineMessages({
  modalTitleWithPhaseNameFormatted: {
    id: 'comments.modalTitleWithPhaseNameFormatted',
    defaultMessage: 'Comments of {phaseName}',
  },
  contextTypeEstimationLabel: {
    id: 'comments.contextTypeEstimationLabel',
    defaultMessage: 'Estimation',
  },
  contextTypeResourcingLabel: {
    id: 'comments.contextTypeResourcingLabel',
    defaultMessage: 'Resource',
  },
  contextTypeCostingLabel: {
    id: 'comments.contextTypeCostingLabel',
    defaultMessage: 'Costs',
  },
  typeMessagePlaceholder: {
    id: 'comments.typeMessagePlaceholder',
    defaultMessage: 'Type your message',
  },
  hintTitle: {
    id: 'comments.hintTitle',
    defaultMessage: 'Press Ctrl (Cmd on Mac) + Enter to send and Esc to close window',
  },
  messageLabel: {
    id: 'comments.messageLabel',
    defaultMessage: 'Message:',
  },
  postingComment: {
    id: 'comments.postingComment',
    defaultMessage: 'Posting comment',
  },
  emptyState: {
    id: 'comments.emptyState',
    defaultMessage: 'No comments yet — start the conversation.',
  },
});
